const UAE_COUNTRY_CODE = '971'
const UAE_MOBILE_WITHOUT_TRUNK = /^5\d{8}$/

function normalizePhone(value = '') {
  const input = String(value).trim()
  if (!input) return ''

  let digits = input.replace(/\D/g, '')
  if (!digits) return input

  if (digits.startsWith('00')) {
    digits = digits.slice(2)
    return `+${digits}`
  }

  if (digits.startsWith('0')) {
    return `+${UAE_COUNTRY_CODE}${digits.slice(1)}`
  }

  if (UAE_MOBILE_WITHOUT_TRUNK.test(digits)) {
    return `+${UAE_COUNTRY_CODE}${digits}`
  }

  return `+${digits}`
}

function normalizeEmail(value = '') {
  return String(value).trim().toLowerCase()
}

function hashFields(data = {}) {
  const next = { ...data }
  if (next.email != null) next.email = normalizeEmail(next.email)
  if (next.phone_number != null) next.phone_number = normalizePhone(next.phone_number)
  return next
}

module.exports = { normalizePhone, normalizeEmail, hashFields }
